export default "__VITE_ASSET__KprD7pTv__"